import { render, staticRenderFns } from "./Imprints.vue?vue&type=template&id=2c3a54ca&"
import script from "./Imprints.vue?vue&type=script&lang=js&"
export * from "./Imprints.vue?vue&type=script&lang=js&"
import style0 from "./Imprints.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports